import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

const messagePattern: any[] = [
    {
      message: 'Contener por lo menos 8 caracteres',
      pattern: function(val: string) {
        return val?(""+val).length>=8:false;
      }
    },
    {
      message: 'Incluir por lo menos un número',
      pattern: function(val: string) {
        const format = /\d/;
        return val?format.test(val):false;
      }
    },
    {
      message: 'Incluir por lo menos una letra mayúscula',
      pattern: function(val: string) {
        const format = /[A-Z]/;
        return val?format.test(val):false;
      }
    },
    {
      message: 'Incluir por lo menos un caracter especial (!@#$%^&*)',
      pattern: function(val: string) {
        const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return val?format.test(val):false;
      }
    }
  ]

export function password(): ValidatorFn {
    
  return (control: AbstractControl): (ValidationErrors | null) => {
    let value = control.value as string;
    let output = {}; 
    let isValid = true;
    if(value) {
        if(!messagePattern[0].pattern(value)) {
            output['min'] = true;
            isValid = false;
        } 
        if(!messagePattern[1].pattern(value)) {
            output['number'] = true;
            isValid = false;
        } 
        if(!messagePattern[2].pattern(value)) {
            output['lower'] = true;
            isValid = false;
        } 
        if(!messagePattern[3].pattern(value)) {
            output['special'] = true;
            isValid = false;
        } 
        return output;
    } 
    return null;
  }
}